import React, { useState } from "react";
import { Group, Text, Menu, Button, ActionIcon, Box } from "@mantine/core";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { solid } from "@fortawesome/fontawesome-svg-core/import.macro";

export default function FilterConditionSelector({
  label,
  condition,
  conditionData,
  onChangeCondition,
  onClearFilter
}) {
  const [openedMenu, setOpenedMenu] = useState(false);

  return (
    <Group pl={8} pr={8} spacing={0} align="center">
      <Text size="xs" color="dimmed" pt={3}>{label}</Text>
      <Menu
        opened={openedMenu}
        zIndex={99999}
        radius="md"
        styles={{ item: { fontSize: 12, padding: 8 } }}
        onClose={() => setOpenedMenu(false)}
        control={
          <Button
            variant="subtle"
            color="gray"
            size="xs"
            compact
            m={0}
            mx={2}
            px={3}
            onClick={() => setOpenedMenu(!openedMenu)}
          >
            <Group spacing={0}>
              <Text size="xs" transform="lowercase" color="#a3a3a3" weight={500} mx={3}>
                {conditionData.find(item => item.value === condition)?.label || conditionData[0].label}
              </Text>
              <FontAwesomeIcon icon={solid("caret-down")} size="xs" color="#a3a3a3" />
            </Group>
          </Button>
        }
      >
        {conditionData.map((item) => (
          <Menu.Item
            key={item.value}
            onClick={() => {
              if (typeof onChangeCondition === "function") {
                onChangeCondition(item);
              }
            }}
          >
            {item.label}
          </Menu.Item>
        ))}
      </Menu>
      {typeof onClearFilter === "function" && (
        <>
          <Box sx={{ flex: 1 }} />
          <ActionIcon size="sm" sx={{ top: 2 }} onClick={onClearFilter}>
            <FontAwesomeIcon icon={solid("xmark")} color="grey" size="sm" />
          </ActionIcon>
        </>
      )}
    </Group>
  );
}